import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { cpfPercentageFLIValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import CPFPercentageForm from "Components/Form/CPFPercentageFrom";
import { useInsertCPFPercentageFliMutation } from "AppQuries/master/CpfPercenatgeFli/cpf-percentage-fli";
import CPFPercentageFLI from "./CPFPercentageFLI";
import CPFPercentageFLIForm from "Components/Form/CPFPercentageFLI";

const AddCPFPercentageFLI = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addCPFPercentage,
    isPending,
    isError,
    error,
  } = useInsertCPFPercentageFliMutation();
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      code: 0,
      cpftype: "",
      ageFrom: "",
      ageTo: "",
      salaryFrom: "",
      salaryTo: "",
      employeePercentage: "",
      employerPercentage: "",
      // employeePercentageSalaryCeiling: "",
      isActive: true,
      createUser: userData.userName,
      createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      modifyUser: userData.userName,
      modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
    },
    resolver: yupResolver(cpfPercentageFLIValidation),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  console.log(errors);
  const onSubmit = (payload) => {
    console.log(payload);
    addCPFPercentage(payload, {
      onSuccess: (data) => {
        if (data === true) {
          setMessage("CPF Percentage FLI Added Successfully.");
          setShowSuccessToast(true);
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.cpfPercentageFLI}`);
          }, 1000);
        } else {
          setMessage("Something went wrong.");
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New CPF Percentage FLI</h4>
                    <h6>Add your new cpf percengate details </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save CPF Percentage FLI
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save CPF Percentage FLI
                      </Tooltip>
                    }
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.master}${all_routes.cpfPercentageFLI}`}
                    >
                      <i className="fa fa-reply me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add CPF Percentage FLI</h4>
                    </div>
                    <div className="card-body">
                      <CPFPercentageFLIForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddCPFPercentageFLI;
